import { checkPassword } from '@common/utils/validators/check-password';

export const validateNewPassword = (_: string, value: string) => {
  return checkPassword(value)
    ? Promise.resolve()
    : Promise.reject(new Error('Пароль должен быть не менее 8 символов содержать латинские буквы и цифры'));
};
